require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-object-oriented-programming-use-an-iife-to-create-a-module.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-object-oriented-programming-use-an-iife-to-create-a-module");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-object-oriented-programming-use-an-iife-to-create-a-module!./.cache/json/javascript-algorithms-and-data-structures-object-oriented-programming-use-an-iife-to-create-a-module.json
// module id = 2470
// module chunks = 231608221292675